angular
  .module('ManagerControllers')

  .controller('ManagerTeachersCtrl', [
    '$scope',
    '$mdDialog',
    'api',
    '$mdToast',
    function($scope, $mdDialog, api, $mdToast) {
      console.log('scope', $scope);
    }
  ]);
